import React, { FC, useEffect } from "react"
import { useRequest } from "ahooks"
import { getAreaGeo } from "@api/report"

/**
 * 显示室内地图
 * @param AMap
 * @param mapIns
 * @param geo
 * example: https://lbs.amap.com/api/javascript-api/example/overlayers/geojson/
 */
const showPolygon = (AMap: any, mapIns: any, geo: any) => {
  var geojson = new AMap.GeoJSON({
    geoJSON: geo,
    // 还可以自定义getMarker和getPolyline
    getPolygon: function (feature: any, lnglats: any) {
      return new AMap.Polygon({
        path: lnglats,
        strokeWeight: 2,
        strokeColor: "#00FFF1",
        fillColor: "#00FFF1",
        fillOpacity: 0.1,
      })
    },
  })
  geojson.setMap(mapIns)
  return geojson
}

/**
 * LayerAreaGeo
 * @param param0
 */
const LayerAreaGeo: FC<any> = ({ map, visible }) => {
  const { data } = useRequest(getAreaGeo, {})

  useEffect(() => {
    let layer
    if (map && data) {
      let AMap = window.AMap
      layer = showPolygon(AMap, map, data)
    }
    return () => {
      layer && layer.setMap(null)
    }
  }, [map, data])

  return null
}

export default LayerAreaGeo
